export default __webpack_public_path__ + "static/media/avatar-bts-jhope.0000fd24.png";